module.exports = __webpack_public_path__ + "img/dgm.efe80a52.webp";